import React from "react";

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">About us </h1>
      <p>hej.........................</p>
    </section>
  );
};

export default About;
